import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/park/coupon/balance/page/v2', Object.assign({}, options, {
    params
  }));

export const lastEndTime = (params, options) =>
  request.get('/api/v4ward/park/coupon/balance/lastEndTime/v2', Object.assign({}, options, {
    params
  }));

export const getCouponAmount = (params, options) =>
  request.get('/api/v4ward/park/coupon/balance/couponAmount/v2', Object.assign({}, options, {
    params
  }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/park/coupon/balance/detail/v2', Object.assign({}, options, {
    params
  }));

export const remove = (params, options) =>
  request.post('/api/v4ward/park/coupon/balance/remove/v2', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/park/coupon/balance/save/v2', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/park/coupon/balance/submit/v2', params, options);
